import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 25
  },
  appliancesTitle: {
    flex: 1,
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[100],
    margin: '10px 0px 0px'
  },
  time: {
    flex: 1,
    fontSize: 16,
    color: colour.grey[400],
    textAlign: 'right',
    margin: '10px 0px 0px'
  }
});
